<template>
	<div>
		<div v-if="loading">
			<bouncing-component></bouncing-component>
		</div>
		<div class="content" v-else>
			<div v-if="visualizations.length > 0">
				<render-index-table :visualizations="visualizations"></render-index-table>

				<b-pagination align="center" size="md" class="clearfix"
							:total-rows="visualizations.length"
							v-model="pagination.currentPage"
							:limit="pagination.limit"
							:per-page="pagination.limit"
							@change="change">
				</b-pagination>
			</div>
			<div v-else class="text-center">
				<em>there isn't a visualization using this query</em>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import ChartComponent from '../../components/Chart.vue';
	import BigNumberComponent from '../../components/BigNumber.vue';
	import RenderIndexTable from '../visualizations/RenderIndexTable.vue';
	import BouncingComponent from '../../components/Bouncing-loader.vue';
	export default {
		props: ['query_id'],
		data() {
			return {
				pagination: {
					currentPage: 1,
					limit: 50
				},
				unwatch: '',
				loading: true
			}
		},
		created() {
			this.loading = true;
			this.$store.dispatch('queries/fetchVisualizations', this.query_id).finally(() => {
				this.loading = false;
			});
			this.unwatch = this.$store.watch(
				(state)=>
					this.$store.state.organizationSelected
				,
				(newValue, oldValue)=>{
					this.$store.dispatch('queries/setInitialStatus');
					this.$store.dispatch('clearMessages');
					this.$router.replace({ name: 'query.create' });
				},
			);
		},
		computed: {
			...mapState('queries', {
				visualizations: 'visualizations'
			}),
		},
		components: {
			ChartComponent,
			BigNumberComponent,
			RenderIndexTable,
			BouncingComponent
		},
		methods: {
			change(page) {
				this.pagination.currentPage = page;
			},
		},
		beforeDestroy() {
			this.$store.commit('queries/SET_VISUALIZATIONS', []);
			this.unwatch();
		},
	}
</script>

<style scoped>
	.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
		background-color: #ffffff;
		border-bottom: solid 1px #ffffff;
	}
</style>